module.exports = __webpack_public_path__ + "static/img/btn-satisfaction-2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/btn-satisfaction-2.png
// module id = 520
// module chunks = 0